import { Component } from "react";
import cookie from "react-cookies";
import { Button, Col, Input, message, Row, Spin, Switch, Select, Checkbox, InputNumber } from "antd";
import { get, post } from "../../helper/request";
import { error_manager } from "../../helper/error_manager";
import { antdSpinLoaderIcon } from "../../utils/const";
import '../../asset/style/add_case.css';
import { Divider } from "@mui/material";

const { Option } = Select;

class BackupSettingsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isBackupOn: false,
            frequency: "daily",
            maxBackups: 5,
            localCheck: false,
            AWSS3Check: false,
            pathToLocalBackup: "",
            pathToS3Backup: "s3://morphle-dicom/backup_testing",
            isAWSProfileOn:false,
            isFormChanged: false,
            pathToLocalBackup: ''
        };
    }

    componentDidMount() {
        this.updateBackupConfigs();
    }


    updateBackupConfigs = async () => {
        this.setState({ isFetching: true });
        try {
            let url = `/api/get_backup_configs/`;
            await get(url).then(backup_data => {
                if(backup_data.message==='config_file_not_created'){
                    this.setState({isBackupOn: false, pathToLocalBackup:backup_data.morphle_home_path})
                    return
                }
                this.setState({
                    isBackupOn: backup_data.isBackup,
                    frequency: backup_data.frequency,
                    maxBackups: backup_data.maxBackups,
                    pathToLocalBackup: backup_data.morphle_home_path,
                });
                backup_data.locationConfig.forEach((location) => {
                    if (location.type == "local") {
                        this.setState({ pathToLocalBackup: location.path, localCheck:true })
                    }
                    if (location.type == "AWS_S3") {
                        this.setState({ pathToS3Backup: location.path, AWSS3Check:true })
                    }
                })
                return
            })
        } catch (err) {
            error_manager("Unable to fetch Backup configurations. Contact Admin", err)
        } finally {
            this.setState({ isFetching: false })
        }
    }


    handleInputChange = (fieldName, value) => {
        this.setState({
            [fieldName]: value,
            isFormChanged: true,
        });
    };

    saveUserDetails = () => {
        if ((!this.state.localCheck && !this.state.AWSS3Check && this.state.isBackupOn)){
            message.error("atleast location should be enabled! or disable backup by clicking on toggle")
            return
        }

        const url = "/api/backup_setup/"
        let data = {
            id: cookie.load('user_id'),
            isBackup: this.state.isBackupOn,
            maxBackups: this.state.maxBackups,
            frequency: this.state.frequency,
            isBackupOnLocal: this.state.localCheck,
            isBackupOnAWS: this.state.AWSS3Check,
        }
        if (this.state.localCheck) {
            data['local_path'] = this.state.pathToLocalBackup
        }
        if (this.state.AWSS3Check) {
            data['AWS_S3_path'] = this.state.pathToS3Backup
        }

        if(!this.state.isBackupOn){
            data = {
                isBackup: this.state.isBackupOn,
            }
        }

        return post(url, data).then(() => {
            this.setState({ isFormChanged: false });
            message.success("Backup settings updated")
        }).catch(err => {
            if (err.response.status === 400 && err.response.data) {
                message.error(err.response.data, 2.5);
            } else {
                message.error("Some error occured. Not able to save changes.", 2.5);
            }
        })
    }

    handleBackupSwitch = async (value) => {
        if(value==true){
            await this.updateBackupConfigs()
        }
        this.setState({ isBackupOn: value, isFormChanged: true })
        
        
    }

    handleMaxBackupsChange = (value) => {
        this.setState({ maxBackups: value, isFormChanged: true })
    }

    handleFrequencyChange = (value) => {
        this.setState({ frequency: value, isFormChanged: true })
    }

    render() {

        return (
            <div className={"full-parent"} style={{ backgroundColor: 'white', padding: 20 }}>
                <Spin spinning={this.state.isFetching} indicator={antdSpinLoaderIcon}>
                    <div className="full-parent">
                        <div style={{ fontSize: 20, fontWeight: 400, marginLeft: 10 }}>
                            Backup Settings
                        </div>
                        <Divider color={"#000"} style={{ opacity: '0.2', margin: 20 }} />
                        <Row style={{ marginBottom: 30 }}>
                            <Col span={2} offset={1}>
                                <b>Backup</b>
                            </Col>
                            <Col span={7}>
                                <Switch checked={this.state.isBackupOn} onChange={this.handleBackupSwitch} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={23} offset={1}>
                                <b>Frequency</b>
                            </Col>
                            <Col span={9} offset={1}>
                                <Select
                                    defaultValue={this.state.frequency}
                                    style={{ width: "100%" }}
                                    onChange={this.handleFrequencyChange}
                                    disabled={!this.state.isBackupOn}
                                    value={this.state.frequency}
                                >


                                    <Option value="hourly">Hourly</Option>
                                    <Option value="daily">Daily</Option>
                                    <Option value="weekly">Weekly</Option>
                                    <Option value="monthly">Monthly</Option>
                                    <Option value="yearly">Yearly</Option>
                                </Select>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>How frequent do you want data to be backed up</div>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>Data will be backed up <b>{this.state.frequency}</b></div>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: 30 }}>
                            <Col span={4} offset={1}>
                                <b>Backup Locations</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4} offset={1}>
                                <Checkbox checked={this.state.localCheck} disabled={!this.state.isBackupOn} onChange={(e) => this.setState({ localCheck: e.target.checked, isFormChanged: true })}><b>Local</b></Checkbox>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>
                                    Choose local if you want to save data locally
                                </div>
                            </Col>
                        </Row>

                        {this.state.localCheck && <Row style={{ marginTop: 10 }}>
                            <Col span={23} offset={1}>
                                <b>Path to save local backup</b>
                            </Col>
                            <Col span={9} offset={1}>
                                <Input placeholder="/media/scandrive"
                                    value={this.state.pathToLocalBackup}
                                    style={{ cursor: 'auto' }}
                                    autoComplete="off"
                                    name="pathToLocalBackup"
                                    allowClear
                                    disabled={!this.state.isBackupOn}
                                    onChange={(e) => this.handleInputChange('pathToLocalBackup', e.target.value)}
                                />
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>Enter location to save encrypted backup. <br />This will create a backups folder in that directory, which would have all the different folders for different frequencies.</div>
                            </Col>
                        </Row>}



                        <Row style={{ marginTop: 30 }}>
                            <Col span={4} offset={1}>
                                <Checkbox checked={this.state.AWSS3Check} disabled={!this.state.isBackupOn} onChange={(e) => this.setState({ AWSS3Check: e.target.checked, isFormChanged: true })}><b>AWS S3</b></Checkbox>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>
                                    Choose if you want to save your data in AWS cloud provider. You have to provide a S3 to store in S3 bucket.
                                </div>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>
                                    If you want to use your <b>own AWS account</b> to store backup contact support
                                </div>
                            </Col>
                        </Row>




                        {this.state.AWSS3Check &&
                            <Row style={{ marginTop: 30 }}>
                                <Col span={23} offset={1}>
                                    <b>S3 Path to save AWS backup</b>
                                </Col>
                                <Col span={9} offset={1}>
                                    <Input placeholder="s3://{Bucket name}/{Prefix}"
                                        value={this.state.pathToS3Backup}
                                        style={{ cursor: 'auto' }}
                                        autoComplete="off"
                                        name="pathToS3Backup"
                                        allowClear
                                        disabled={!this.state.isBackupOn}
                                        onChange={(e) => this.handleInputChange('pathToS3Backup', e.target.value)}
                                    />
                                </Col>
                                <Col span={23} offset={1}>
                                    <div style={{ fontSize: 11 }}>Enter the S3 path to save encrypted backup. <br />This will create a backups folder in that directory, which would have all the different folders for different frequencies.</div>
                                </Col>
                                <Col span={23} offset={1}>
                                    <div style={{ fontSize: 11 }}>Contact Morphle support for assistance</div>
                                </Col>
                            </Row>
                        }

                        <Row style={{ marginTop: 30 }}>
                            <Col span={23} offset={1}>
                                <b>Backup Limit</b>
                            </Col>
                            <Col span={9} offset={1}>
                                <InputNumber placeholder="5" value={this.state.maxBackups}
                                    style={{ cursor: 'auto', width: "100%" }} onChange={this.handleMaxBackupsChange}
                                    disabled={!this.state.isBackupOn}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>Total number of backups for a frequency category</div>
                            </Col>
                        </Row>

                        <Row gutter={[0, 24]}>
                            <Col span={23} offset={1}>
                                <Button onClick={this.saveUserDetails} disabled={!this.state.isFormChanged}
                                    style={{ borderColor: 'rgb(112,11,128)', color: 'rgb(112,11,128)' , opacity:this.state.isFormChanged?'100%':'30%' }}>
                                    Save Changes
                                </Button>
                            </Col>
                            <Col span={23} offset={1}>
                                <div style={{ fontSize: 11 }}>Click on Save changes button to save your backup setting.</div>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </div>
        );
    }
}

export default BackupSettingsView;
